import { render } from "./article-category.vue?vue&type=template&id=2c7f98f2&scoped=true&ts=true"
import script from "./article-category.vue?vue&type=script&lang=ts"
export * from "./article-category.vue?vue&type=script&lang=ts"

import "./article-category.vue?vue&type=style&index=0&id=2c7f98f2&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7f98f2"]])

export default __exports__